export default __webpack_public_path__ + "static/media/certification_tips.a0825ec2.png";